import { render, staticRenderFns } from "./Homekind.vue?vue&type=template&id=4450260c&scoped=true"
import script from "./Homekind.vue?vue&type=script&lang=js"
export * from "./Homekind.vue?vue&type=script&lang=js"
import style0 from "./Homekind.vue?vue&type=style&index=0&id=4450260c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4450260c",
  null
  
)

export default component.exports